import React, { useEffect, useState } from "react";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import PaginationComponent from "../../../../components/common/Pagination/index";
import SideBar from "../../../../components/common/SideBar/SideBarNew";
import {
  emptyPaginationObj,
  LOADER_STATUS,
  POLICIES_LIST_LIMIT,
  StatusOptions,
} from "../../../../Constants/constant";
import { resolveListingSort } from "../../../../Constants/listingSort";
import { LoginContext } from "../../../../helpers/LoginContext";
import { getPaginationObj } from "../../../../Utils/utils";
import TeamManagementListTable from "./TeamManagementListTable";

const TeamManagment = (props) => {
  const { getTeamManagmentListCall, teamManagementList, loading } = props;

  const { sideBarPadding, isUserGracePeriodOver } =
    React.useContext(LoginContext);

  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [paginationObj, setPaginationObj] = useState(
    teamManagementList
      ? getPaginationObj(
          teamManagementList.employees,
          teamManagementList.query_params
        )
      : emptyPaginationObj
  );
  const [sortBy, setSortBy] = useState("first_name");
  const [selectedStatus, setSelectedStatus] = useState( { label: "Active", value: "active" });

  useEffect(() => {
    if (!loading && renderLoading === LOADER_STATUS.PENDING) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [loading]);


  useEffect(() => {
    if (teamManagementList) {
      setPaginationObj(
        getPaginationObj(
          teamManagementList.employees,
          teamManagementList.query_params
        )
      );
    }
  }, [teamManagementList]);

  useEffect(() => {
    if (teamManagementList) {
      setPaginationObj(
        getPaginationObj(
          teamManagementList.employees,
          teamManagementList.query_params
        )
      );
    }
  }, []);

  const fetchFormTemplateList = async (filters) => {

    if (!filters || filters === undefined) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, { per_page: POLICIES_LIST_LIMIT, search_contact: 1 });
    let bodyFilter = filters.hasOwnProperty("filter") ? filters.filter : null;
    if (filters.hasOwnProperty("filter")) {
      delete filters.filter;
    }
    if (filters.status === "both") {
      bodyFilter = null;
    }
    if (renderLoading === LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.PENDING);
    }
    getTeamManagmentListCall({ filters, bodyFilter });
  };

  const checkStatus = (status) => {
    return status === "active" ? true : false;
  };

  const handleFetch = (obj, sortBy) => {
    const statusValue = obj.status ?? selectedStatus?.value ?? "active";
    if (!obj.hasOwnProperty("status")) {
      obj.status = statusValue;
    }
    Object.assign(obj, resolveListingSort(obj, sortBy, paginationObj));
    if (paginationObj.page) {
      Object.assign(obj, { page: obj.page ? obj.page : paginationObj.page });
    }
    if (paginationObj.filter) {
      !paginationObj.filter.hasOwnProperty("status")
        ? Object.assign(obj, {
            filter: paginationObj.filter,
          })
        : Object.assign(obj, {
            filter: {
              status: paginationObj.filter.status.map((page) => page),
            },
          });
    }
    if (obj.hasOwnProperty("search")) {
          Object.assign(obj, { page: 1, search: obj.search ,status:selectedStatus?.value});
    }
    if (paginationObj.search && !obj.hasOwnProperty("search")) {
      Object.assign(obj, { search: paginationObj.search });
    }
    if (statusValue !== "both") {
      Object.assign(obj, {
        filter: {
          status: [checkStatus(statusValue)],
        },
      });
    }
    fetchFormTemplateList({ ...obj });
  };

  useEffect(() => {
    handleFetch(
      { status: "active", sort_field: "first_name", sort_order: "asc" },
      "first_name"
    );
  }, []);

  return (
    <div className='min-h-full pb-10'>
      <SideBar />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        } flex flex-col min-w-0 w-full`}
      >
        <main className='flex-1 min-w-0 w-full'>
          {teamManagementList && teamManagementList === null ? (
            <div
              className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
            >
              <CircularLoader
                classes='flex justify-center items-center'
                classloader='loader-l'
              />
            </div>
          ) : (
            <TeamManagementListTable
              templateList={
                teamManagementList &&
                teamManagementList?.employees &&
                teamManagementList?.employees?.data &&
                teamManagementList?.employees?.data?.length > 0
                  ? teamManagementList?.employees?.data
                  : []
              }
              isLoading={loading}
              queryParams={paginationObj}
              formCategoriesList={StatusOptions}
              handleFetch={handleFetch}
              getSortBy={(e) => setSortBy(e)}
              renderLoading={renderLoading}
              isUserGracePeriodOver={isUserGracePeriodOver}
              setSelectedStatus={setSelectedStatus}
              selectedStatus={selectedStatus}
            />
          )}
        </main>
        <div>
          {teamManagementList && teamManagementList !== null && (
            <div className='bg-white w-full sm:px-6 lg:px-8 py-2'>
              <PaginationComponent
                page={paginationObj.page}
                activeListLength={
                  teamManagementList &&
                  teamManagementList?.employees?.data?.length > 0
                    ? teamManagementList?.employees?.data
                    : []
                }
                limit={POLICIES_LIST_LIMIT}
                totalList={paginationObj.total}
                handlePagination={(e) => {
                  const obj = paginationObj;
                  obj.page = e;
                  setPaginationObj({ ...obj });
                  handleFetch({status:selectedStatus?.value}, sortBy);
                }}
                totalPages={paginationObj.totalPages}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamManagment;
